export { LoginPage as default } from './lib/login.page';
